import {Injectable} from '@angular/core';

import Swal from "sweetalert2";

import {EventResponse} from "@numizmat/services-models/core";

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  public showUserBlockWarning(username: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: "Блокиране на потребител",
        html: `
      <p>
        Сигурни ли сте, че искате да блокирате <strong>${username}</strong>?
      </p>
      <p>Блокираните потребители не могат да участват в наддавания, да потвърждават покупки или да добавят коментари към всички Ваши обяви.</p>
      <p>Можете да премахнете блокирането по всяко време от настройките на Вашия профил.</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Блокирай",
        confirmButtonColor: "#d33",
        cancelButtonText: "Затвори",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch((err) => {
        reject(err);
      });
    });
  }

  public showStopAdWarning(adTitle: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: "Спиране на обява",
        html: `
        <p>
          Сигурни ли сте, че искате да спрете обявата за артикул <strong>${adTitle}</strong>?
        </p>
        <p>
          Обявата ще бъде маркирана като <strong>завършила без сделка</strong> и няма да бъде видима за другите потребители.
        </p>
        <p>
          Ще имате възможност да я активирате отново чрез опцията <strong>„Обновяване на обявата“</strong>.
        </p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Спиране",
        confirmButtonColor: "#d33",
        cancelButtonText: "Отказ",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        resolve(result.isConfirmed);
      }).catch(reject);
    });
  }

  public showDeleteAdWarning(adTitle: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: "Изтриване на обява",
        html: `
        <p>
          Сигурни ли сте, че искате да <strong>изтриете</strong> обявата за артикул <strong>${adTitle}</strong>?
        </p>
        <p>
          Това действие е необратимо.
        </p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Изтриване",
        confirmButtonColor: "#d33",
        cancelButtonText: "Отказ",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        resolve(result.isConfirmed);
      }).catch(reject);
    });
  }

  public showAdOfferAcceptWarning(adTitle: string, offerPrice: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: "Приемане на предложение",
        html: `
      <p>
        Сигурни ли сте, че искате да <strong>приемете</strong> предложението от
        <strong>${offerPrice.toFixed(2)} лв.</strong> за артикул <strong>${adTitle}</strong>?
      </p>`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Да, приеми",
        confirmButtonColor: "#28a745",
        cancelButtonText: "Затвори",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        resolve(result.isConfirmed);
      }).catch(reject);
    });
  }

  public showAdCounterOfferAcceptWarning(adTitle: string, counterOfferPrice: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: "Приемане на контрапредложение",
        html: `
      <p>
        Сигурни ли сте, че искате да <strong>приемете</strong> контрапредложението от
        <strong>${counterOfferPrice.toFixed(2)} лв.</strong> за артикул <strong>${adTitle}</strong>?
      </p>`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Да, приеми",
        confirmButtonColor: "#28a745",
        cancelButtonText: "Затвори",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        resolve(result.isConfirmed);
      }).catch(reject);
    });
  }

  public showAdOfferRejectWarning(adTitle: string, offerPrice: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: "Отказ на предложение",
        html: `
        <p>
          Сигурни ли сте, че искате да <strong>откажете</strong> предложението от
          <strong>${offerPrice.toFixed(2)} лв.</strong> за артикул <strong>${adTitle}</strong>?
        </p>
        <p class="mb-0">
          Това действие е необратимо.
        </p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Да, откажи",
        confirmButtonColor: "#d33",
        cancelButtonText: "Затвори",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        resolve(result.isConfirmed);
      }).catch(reject);
    });
  }

  public showAdCounterOfferRejectWarning(adTitle: string, counterOfferPrice: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: "Отказ на контрапредложение",
        html: `
        <p>
          Сигурни ли сте, че искате да <strong>откажете</strong> контрапредложението от
          <strong>${counterOfferPrice.toFixed(2)} лв.</strong> за артикул <strong>${adTitle}</strong>?
        </p>
        <p class="mb-0">
          Това действие е необратимо.
        </p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Да, откажи",
        confirmButtonColor: "#d33",
        cancelButtonText: "Затвори",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        resolve(result.isConfirmed);
      }).catch(reject);
    });
  }

  public showDeleteMessageWarning(interlocutorUsername: string, adTitle: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: "Изтриване на разговор",
        html: `
        <p>
          Сигурни ли сте, че искате да изтриете разговора с потребител <strong>${interlocutorUsername}</strong> за артикул <strong>${adTitle}</strong>?
        </p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Изтрий",
        confirmButtonColor: "#d33",
        cancelButtonText: "Затвори",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch((err) => {
        reject(err);
      });
    });
  }

  public showEventInfo(event: EventResponse): void {
    const details = [
      event.date && `<p class="p-2 text-start bg-light shadow border rounded-1"><strong>Дата:</strong> ${event.date}</p>`,
      event.duration && `<p class="p-2 text-start bg-light shadow border rounded-1"><strong>Продължителност:</strong> ${event.duration}</p>`,
      event.location && `<p class="p-2 text-start bg-light shadow border rounded-1"><strong>Място:</strong> ${event.location}</p>`,
      event.organizedBy && `<p class="p-2 text-start bg-light shadow border rounded-1"><strong>Организатор:</strong> ${event.organizedBy}</p>`,
      event.additionalInformation && `<p class="p-2 text-start bg-light shadow border rounded-1"><strong>Допълнителна информация:</strong> ${event.additionalInformation}</p>`,
      event.reservationContact && `<p class="p-2 text-start bg-light shadow border rounded-1"><strong>За резервация на маса:</strong> ${event.reservationContact}</p>`,
      event.longDescription && `<p>${event.longDescription}</p>`,
    ].filter(Boolean).join("");
    Swal.fire({
      title: event.title,
      html: details,
      showConfirmButton: true,
      confirmButtonText: "Затвори",
      confirmButtonColor: "#3085d6",
    }).then();
  }

  public showUserRatingInfo(): void {
    Swal.fire({
      title: "Потребителски рейтинг",
      html: `
      <p>
        Потребителският рейтинг е индикатор за активността и доверието към потребителя в платформата.
        Той се базира на извършените действия и отзивите от други потребители.
      </p>
      <table class="mb-4 table table-striped table-hover">
        <thead class="text-start">
          <tr>
            <th scope="col">Маркер</th>
            <th scope="col">Рейтинг</th>
          </tr>
        </thead>
        <tbody class="text-start">
          <tr>
            <th class="fw-normal" scope="row">Няма</th>
            <td>Под 0</td>
          </tr>
          <tr>
            <th scope="row"><i class="fa-solid fa-star text-muted"></i></th>
            <td>0 - 9</td>
          </tr>
          <tr>
            <th scope="row"><i class="fa-solid fa-star nz-color-star"></i></th>
            <td>10 - 49</td>
          </tr>
          <tr>
            <th scope="row">
              <i class="fa-solid fa-star nz-color-star"></i>
              <i class="fa-solid fa-star nz-color-star"></i>
            </th>
            <td>50 - 199</td>
          </tr>
          <tr>
            <th scope="row">
              <i class="fa-solid fa-star nz-color-star"></i>
              <i class="fa-solid fa-star nz-color-star"></i>
              <i class="fa-solid fa-star nz-color-star"></i>
            </th>
            <td>200 - 499</td>
          </tr>
          <tr>
            <th scope="row"><i class="fa-solid fa-gem nz-color-gem"></i></th>
            <td>500 - 999</td>
          </tr>
          <tr>
            <th scope="row">
              <i class="fa-solid fa-gem nz-color-gem"></i>
              <i class="fa-solid fa-gem nz-color-gem"></i>
            </th>
            <td>1000 - 2499</td>
          </tr>
          <tr>
            <th scope="row">
              <i class="fa-solid fa-gem nz-color-gem"></i>
              <i class="fa-solid fa-gem nz-color-gem"></i>
              <i class="fa-solid fa-gem nz-color-gem"></i>
            </th>
            <td>2500 - 4999</td>
          </tr>
          <tr>
            <th scope="row"><i class="fa-solid fa-crown nz-color-crown"></i></th>
            <td>5000 - 9999</td>
          </tr>
          <tr>
            <th scope="row">
              <i class="fa-solid fa-crown nz-color-crown"></i>
              <i class="fa-solid fa-crown nz-color-crown"></i>
            </th>
            <td>10000 - 19999</td>
          </tr>
          <tr>
            <th scope="row">
              <i class="fa-solid fa-crown nz-color-crown"></i>
              <i class="fa-solid fa-crown nz-color-crown"></i>
              <i class="fa-solid fa-crown nz-color-crown"></i>
            </th>
            <td>Над 19999</td>
          </tr>
        </tbody>
      </table>
      <p>
        За повече информация вижте <a class="btn-link text-decoration-none" href="/terms-conditions">Общите условия</a> на сайта.
      </p>`,
      showConfirmButton: true,
      confirmButtonText: "Затвори",
      confirmButtonColor: "#3085d6",
    }).then();
  }

  public showPublicDirectSaleInfo(): void {
    Swal.fire({
      title: "Обява с фиксирана цена",
      html: `
        <p>При този тип обява купувачите могат да закупят артикула директно на обявената от продавача цена.</p>
        <p>С потвърждаването на покупката купувачът декларира, че се съгласява да заплати крайната цена на артикула и приема <a class="text-decoration-none" href="terms-conditions">общите условия</a> на сайта, както и условията, посочени от продавача.</p>`,
      icon: "info",
      showConfirmButton: true,
      confirmButtonText: "Затвори",
      confirmButtonColor: "#3085d6",
    }).then();
  }

  public showPublicAuctionInfo(): void {
    Swal.fire({
      title: "Обява с наддаване (аукцион)",
      html: `
      <p>
        При този тип обява купувачите могат да участват в наддаването, като зададат максимална сума, която са готови да заплатят.
        Системата ще наддава автоматично до достигането й или до спечелването на наддаването.
        Максималната сума може да бъде коригирана чрез повторно наддаване.
        Ако сте водещ в наддаването, повторното наддаване няма да повиши текущата цена, а ще актуализира само Вашата максимална сума.
      </p>
      <p class="small  fst-italic">
        <div class=" fw-bold">Пример:</div>
        <div class=" small fst-italic">
          При начална цена 10.00 лева и минимална стъпка 2.00 лева Вие откривате наддаването с 20 лева.
          В този момент излизате начело с текуща цена 10.00 лева.
          Ако друг потребител по-късно въведе 12.50 лева, то Вие автоматично ще излезете начело с 14.50 лева.
          Впоследствие, ако трети потребител въведе 20 лева - Вие оставате начело с 20 лева, понеже първи сте наддали с тази сума.
        </div>
      </p>
      <p>С участието си в наддаването купувачът декларира, че приема <a class="text-decoration-none" href="terms-conditions">общите условия</a> на сайта, както и условията, посочени от продавача.</p>
    `,
      icon: "info",
      showConfirmButton: true,
      confirmButtonText: "Затвори",
      confirmButtonColor: "#3085d6",
    }).then();
  }

  public showLoginSuccess(): void {
    Swal.fire({
      title: "Успешен вход",
      html: `
      <p>Добре дошли в Collectoria! Вече имате достъп до всички функционалности на платформата.</p>`,
      icon: "success",
      showConfirmButton: true,
      confirmButtonText: "Затвори",
      confirmButtonColor: "#3085d6"
    }).then();
  }

  public showUsernameInfo(): void {
    Swal.fire({
      title: "Потребителско име",
      html: `
      <p>Потребителското име е важно за вашия профил в системата.</p>
      <p>То ще бъде видимо за другите потребители и може да се използва за вход в системата.</p>`,
      icon: "info",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Затвори"
    }).then();
  }

  public showIdentifierInfo(): void {
    Swal.fire({
      title: "Личен идентификатор",
      html: `
        <p>Можете да използвате това поле за въвеждане на уникален идентификатор за всеки артикул.</p>
        <p>Например, при продажба на множество артикули, може да зададете номера като <strong>C-001, C-002</strong>, което ще улесни тяхното намиране при обработка на поръчки.</p>
        <p><strong>Това поле е видимо само за вас.</strong></p>`,
      icon: "info",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Затвори"
    }).then();
  }

  public showFixedPriceAdTypeInfo(): void {
    Swal.fire({
      title: "Обява с фиксирана цена",
      html: `
        <p>При този тип обява, купувачите могат да закупят артикула директно на обявената от продавача цена.</p>
        <p>Продавачът има право да променя фиксираната цена по всяко време, до момента на сключване на сделка.</p>
        <p><strong>След сключване на сделка, цената не може да бъде променяна.</strong></p>`,
      icon: "info",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Затвори"
    }).then();
  }

  public showAllowOfferInfo(): void {
    Swal.fire({
      title: "Приемане на предложения",
      html: `
      <p>Ако активирате тази опция, купувачите ще могат да Ви изпращат ценови предложения за артикула.</p>
      <p>Всяко предложение ще има валидност от <strong>72 часа</strong>, в рамките на които може да:</p>
      <ul class="text-start">
        <li>Приемете предложението</li>
        <li>Откажете предложението</li>
        <li>Изпратите контрапредложение</li>
      </ul>
      <p>Ако не реагирате в срок, предложението ще бъде анулирано автоматично.</p>
      <p class="mb-0">Функцията е подходяща, ако желаете да дадете повече гъвкавост на потенциалните купувачи.</p>`,
      icon: "info",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Затвори"
    }).then();
  }

  public showAuctionAdTypeInfo(): void {
    Swal.fire({
      title: "Обява с наддаване (аукцион)",
      html: `
        <p>При този тип обява, купувачите могат да участват в наддаване за артикула. Процесът на наддаване продължава до края на аукциона.</p>
        <p>Крайната цена на артикула се определя от най-високото наддаване, направено преди края на аукциона.</p>
        <p><strong>След стартиране на аукциона, началната цена и минималната стъпка не могат да бъдат променяни.</strong></p>`,
      icon: "info",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Затвори"
    }).then();
  }

  public showBuyNowPriceInfo(): void {
    Swal.fire({
      title: "Купи сега цена",
      html: `
        <p>Опцията "Купи сега" позволява на купувачите да закупят артикула веднага на обявената цена, без да участват в наддаване.</p>
        <p>Ако обявата няма "Запазена цена", опцията "Купи сега" се скрива автоматично след първото направено наддаване.</p>
        <p>Ако обявата има "Запазена цена", опцията "Купи сега" автоматично се скрива, когато наддаването достигне или надвиши запазената цена.</p>`,
      icon: "info",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Затвори"
    }).then();
  }

  public showReservedPriceInfo(): void {
    Swal.fire({
      title: "Запазена цена",
      html: `
      <p>При аукцион със зададена "Запазена цена", ако наддаването приключи на цена по-ниска от запазената, аукционът приключва без сделка.</p>
      <p>"Запазената цена" е скрита и е известна само на продавача. Купувачите не виждат конкретната стойност на запазената цена, а само дали текущата цена е достигнала запазената цена.</p>`,
      icon: "info",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Затвори"
    }).then();
  }

  public showBidExtensionTimeInfo(): void {
    Swal.fire({
      title: "Удължаване на аукциона",
      html: `
        <p>Опцията "Удължаване на аукциона" автоматично удължава времето до края на аукциона след всяко наддаване в последната минута.</p>
        <p>Пример: ако аукционът е предвиден да свърши в 20:30 часа и има зададено време за удължаване от 2 минути, при наддаване в последната минута времето до края ще бъде 20:32 часа.</p>`,
      icon: "info",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Затвори"
    }).then();
  }

  public showAutoRenewAfterExpiredInfo(): void {
    Swal.fire({
      title: "Автоматично обновяване след завършване без продажба",
      html: `
      <p>
        Тази опция позволява автоматично обновяване на обявата, когато тя завърши без реализирана продажба.
      </p>
      <p>
        Вместо да създавате нова обява или да я обновявате ръчно, текущата ще остане активна с нова начална и крайна дата.
      </p>
      <p>
        Обявата ще се обновява толкова пъти, колкото е посочено в падащото меню.
      </p>
    `,
      icon: "info",
      showConfirmButton: true,
      confirmButtonText: "Затвори",
      confirmButtonColor: "#3085d6",
    }).then();
  }
}
